import { jsx as c, jsxs as h } from "react/jsx-runtime";
import { useRef as k, useEffect as b, createContext as T, useContext as B } from "react";
import { drawerBlueprint as P } from "./index-blueprint.es.js";
import { Drawer as a } from "vaul";
import x from "clsx";
import { useOverlayState as H } from "@made-people/blueprint-overlay";
import { Heading as R } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
function z(t, r) {
  const l = k(!1);
  b(() => {
    t && l.current && r === !1 && document.querySelectorAll("[data-vaul-drawer]").forEach((n) => {
      var u;
      (u = n.style.transform) != null && u.includes("scale(") && !n.style.transform.includes("scale(1)") && (n.style.transition = "transform 0.5s cubic-bezier(0.32, 0.72, 0, 1)", n.style.transform = "scale(1) translate3d(0, 0, 0)");
    }), l.current = r === !0;
  }, [r, t]);
}
let w = 0, v = 0, g = 0, D = "", m = null;
function $() {
  const { platform: t, maxTouchPoints: r } = window.navigator;
  return /^iP(hone|ad|od)/.test(t) || /^Mac/.test(t) && r > 1;
}
function j() {
  v = window.scrollX, g = window.scrollY, D = window.location.href, m = {
    position: document.body.style.position,
    top: document.body.style.top,
    left: document.body.style.left,
    right: document.body.style.right,
    overflow: document.body.style.overflow
  }, document.body.style.setProperty("position", "fixed", "important"), document.body.style.top = `${-g}px`, document.body.style.left = `${-v}px`, document.body.style.right = "0", document.body.style.overflow = "hidden";
}
function q() {
  if (!m)
    return;
  const { position: t, top: r, left: l, right: i, overflow: n } = m;
  document.body.style.position = t, document.body.style.top = r, document.body.style.left = l, document.body.style.right = i, document.body.style.overflow = n, window.location.href === D && window.scrollTo(v, g), m = null;
}
function E() {
  if (!$())
    return () => {
    };
  let t = !1;
  return m || j(), w += 1, () => {
    t || (t = !0, w -= 1, w === 0 && queueMicrotask(() => {
      w === 0 && q();
    }));
  };
}
const N = T({
  hasOverlay: !0,
  hasHandle: !0,
  direction: "bottom"
}), p = ({
  variants: t,
  hasOverlay: r = !0,
  hasHandle: l = !0,
  hasScaledBackground: i = !0,
  setBackgroundColorOnScale: n = !1,
  children: u,
  direction: y = "bottom",
  header: C,
  repositionInputs: e,
  nested: s,
  ...o
}) => {
  const f = H(o.customOverlayId), d = f.isOpen ?? o.open;
  b(() => {
    o.defaultOpen && f.onChange(!0);
  }, []), b(() => {
    var O;
    typeof d == "boolean" && ((O = o.onOpenChange) == null || O.call(o, d));
  }, [d, o.onOpenChange]), z(s, d), b(() => {
    if (d)
      return E();
  }, [d]);
  const I = s ? a.NestedRoot : a.Root;
  return /* @__PURE__ */ c(
    N.Provider,
    {
      value: { direction: y, variants: t, hasOverlay: r, hasHandle: l, header: C, nested: s },
      children: /* @__PURE__ */ c(
        I,
        {
          ...o,
          repositionInputs: e,
          open: d,
          onOpenChange: f.onChange,
          shouldScaleBackground: s ? !1 : i,
          setBackgroundColorOnScale: s ? !1 : n,
          direction: y,
          noBodyStyles: !0,
          disablePreventScroll: !1,
          children: u
        }
      )
    }
  );
};
function L({
  children: t,
  overlaySettings: r,
  contentSettings: l,
  portalSettings: i
}) {
  const { variants: n, hasOverlay: u, hasHandle: y, direction: C, header: e, nested: s } = B(N), o = P.styles({
    ...n,
    direction: (n == null ? void 0 : n.direction) ?? C
  });
  return /* @__PURE__ */ h(a.Portal, { ...i, children: [
    u && /* @__PURE__ */ c(
      a.Overlay,
      {
        ...r,
        className: x(
          o.overlay,
          s && "z-[90]",
          r == null ? void 0 : r.className
        )
      }
    ),
    /* @__PURE__ */ c(a.Title, { hidden: !0, children: "Drawer" }),
    /* @__PURE__ */ h(a.Description, { hidden: !0, children: [
      " ",
      (l == null ? void 0 : l["aria-description"]) ?? "Drawer"
    ] }),
    /* @__PURE__ */ h(
      a.Content,
      {
        "aria-description": "Content for drawer",
        tabIndex: -1,
        onFocusOutside: (f) => f.preventDefault(),
        ...l,
        className: x(
          o.content,
          s && "z-[91]",
          "focus:outline-none",
          l == null ? void 0 : l.className
        ),
        children: [
          y && /* @__PURE__ */ c("div", { className: o.dragHandle }),
          e != null && e.headingSettings && (e != null && e.headingSettings.badge || e.headingSettings.heading) ? /* @__PURE__ */ h("div", { className: o.header, children: [
            /* @__PURE__ */ c(R, { ...e.headingSettings }),
            e.closeIcon && /* @__PURE__ */ c(a.Close, { className: o.headerCloseIcon, children: e.closeIcon })
          ] }) : (e == null ? void 0 : e.closeIcon) && /* @__PURE__ */ c(a.Close, { className: o.closeIcon, children: e.closeIcon }),
          t
        ]
      }
    )
  ] });
}
p.Trigger = a.Trigger;
p.Close = a.Close;
p.Title = a.Title;
p.Content = L;
export {
  p as Drawer,
  z as useNestedDrawerCleanup
};
//# sourceMappingURL=index.es.js.map
